import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LangContext";

const TEAM = [
  { img: "/team/qse.jpg", name: "Alexandra Dolet", frole: "Fondatrice · Consultante QSE senior", erole: "Founder · Senior HSE consultant", fdesc: "15 ans d'expérience terrain, auditrice ISO 45001 et référente réglementaire de nos clients grands comptes.", edesc: "15 years of field experience, ISO 45001 auditor and regulatory advisor for our key accounts." },
  { img: "/team/ergonome.jpg", name: "Karim Benali", frole: "Ergonome certifié", erole: "Certified ergonomist", fdesc: "Spécialiste de l'analyse des postes et de la prévention des TMS, il pilote nos déploiements d'exosquelettes.", edesc: "Specialist in workstation analysis and MSD prevention, he leads our exoskeleton deployments." },
  { img: "/team/formatrice.jpg", name: "Awa Diallo", frole: "Formatrice SST & incendie", erole: "First-aid & fire safety trainer", fdesc: "Certifiée INRS, plus de 1 200 stagiaires formés au secourisme et à l'évacuation avec une pédagogie saluée.", edesc: "INRS-certified, over 1,200 trainees in first aid and evacuation with acclaimed teaching." },
  { img: "/team/bureautique.jpg", name: "Laurent Mercier", frole: "Formateur bureautique & efficacité", erole: "Office software & effectiveness trainer", fdesc: "20 ans de pédagogie sur Word, Excel, PowerPoint et les écrits professionnels, du débutant à l'expert.", edesc: "20 years teaching Word, Excel, PowerPoint and professional writing, from beginner to expert." },
];

export function TeamBand({ compact = false }) {
  const { t } = useLang();
  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-32" data-testid="team-band">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
        <div>
          <Reveal><p className="overline mb-4" style={{ color: "var(--orange)" }}>{t("Notre équipe", "Our team")}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-none max-w-xl">
              {t("Des experts passionnés, à vos côtés sur le terrain.", "Passionate experts, by your side in the field.")}
            </h2>
          </Reveal>
        </div>
        {!compact && (
          <Reveal delay={0.1}>
            <Link to="/equipe" className="btn-outline px-6 py-3 font-semibold inline-flex items-center gap-2 whitespace-nowrap" data-testid="team-all-btn">
              {t("Découvrir toute l'équipe", "Meet the whole team")} <ArrowRight size={16} />
            </Link>
          </Reveal>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px" style={{ background: "var(--border)", border: "1px solid var(--border)" }}>
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.07}>
            <div className="group h-full flex flex-col" style={{ background: "var(--white)" }} data-testid={`team-member-${i}`}>
              <div className="overflow-hidden">
                <img src={m.img} alt={m.name} loading="lazy"
                  className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display font-bold text-xl">{m.name}</h3>
                <p className="mt-1 text-sm font-semibold flex items-center gap-1.5" style={{ color: "var(--orange)" }}>
                  <BadgeCheck size={14} /> {t(m.frole, m.erole)}
                </p>
                <p className="mt-3 text-sm" style={{ color: "var(--ink-2)" }}>{t(m.fdesc, m.edesc)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
